import script from "./GestionActivo.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionActivo.vue?vue&type=script&setup=true&lang=js"

import "./GestionActivo.vue?vue&type=style&index=0&id=a8bb9a30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8bb9a30"]])

export default __exports__